var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import MapContext from "../../../application/Context/MapContext";
export var InfoBar = function () {
    var t = useTranslation(['news']).t;
    var _a = React.useContext(MapContext), companies = _a.companies, projects = _a.projects;
    return (_jsx("div", __assign({ className: "under-filter-info" }, { children: _jsxs("div", { children: [" ", companies.length + projects.length, " ", t("éléments")] }) })));
};
